/**
 * Historial de análisis — Iter277 (feedback delegados: no repetir trabajo
 * si se vuelve a la misma oportunidad; ver de un vistazo todo lo ya
 * analizado con IA).
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, FileCheck2, ExternalLink } from "lucide-react";
import { API } from "@/context/AuthContext";

const fmtEur = (n) =>
  n == null ? "—" :
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

export default function HistorialAnalisis({ onOpen }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/delegado/oportunidades/historial`)
      .then((r) => setItems(r.data.items))
      .catch(() => toast.error("No se pudo cargar el historial"))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center py-16 text-slate-400" data-testid="delegado-historial-loading"><Loader2 className="animate-spin mx-auto mb-2" size={24} />Cargando historial…</div>;

  if (items.length === 0) {
    return <p className="text-sm text-slate-400 text-center py-10" data-testid="delegado-historial-empty">Todavía no has analizado ningún pliego. Usa "Resumen Ejecutivo" → "Analizar pliego" en cualquier oportunidad.</p>;
  }

  return (
    <div className="space-y-2" data-testid="delegado-historial-list">
      {items.map((it, i) => (
        <button key={i} onClick={() => onOpen?.(it.external_id)}
          data-testid={`delegado-historial-item-${i}`}
          className="w-full text-left bg-white border border-slate-200 hover:border-[#007934] rounded-xl p-3 transition-colors">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <p className="text-sm font-semibold text-slate-800 line-clamp-1 flex items-center gap-1.5"><FileCheck2 size={13} className="text-[#007934] flex-shrink-0" /> {it.title}</p>
              <p className="text-xs text-slate-500 mt-0.5">{it.organism} · {it.municipality}</p>
            </div>
            <ExternalLink size={13} className="text-slate-400 flex-shrink-0 mt-1" />
          </div>
          <div className="flex items-center gap-3 mt-2 text-[11px] text-slate-500">
            <span>Analizado: {it.extracted_at ? String(it.extracted_at).slice(0, 16).replace("T", " ") : "—"}</span>
            <span>Duración: {it.duracion_anios ? `${it.duracion_anios} años` : "—"}</span>
            <span>CAPEX: {fmtEur(it.capex_pliego_eur)}</span>
            <span className="text-slate-400">{it.extracted_by}</span>
          </div>
        </button>
      ))}
    </div>
  );
}
